var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_vm._v(" "),(_vm.$page.props.settings.twitch && _vm.$page.props.settings.show_stream)?_c('TwitchStream',{attrs:{"twitch-url":_vm.$page.props.settings.twitch_url}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }